import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Spinner from "../../common/Spinner";
import { toast } from "react-toastify";
import { checkConnectionStatus, getRequestToken, disconnect} from "../../../api/garminApi";
import "./GarminConnect.css";

function GarminConnectAuthControl({
    user
}) {

    const [processing, setProcessing] = useState(true);
    const [connectionAuthorised, setConnectionAuthorised] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        checkConnectionStatus()
            .then(result => {
                setConnectionAuthorised(result);
                setProcessing(false);
            })
            .catch(error => {
                toast.error(`There has been an issue getting your Garmin connection status: ${error}`);
                errors.onLoad = "Connection status check failed: " + error;
                setErrors(errors);
                setProcessing(false);
            })
    }, [])

    function startConnection(e) {
        e.preventDefault(); 
        setProcessing(true);
        getRequestToken()
            .then(result => {
                var authUrl = `https://connect.garmin.com/oauthConfirm?${result.queryString}`;
                window.location.href = authUrl;
            })
            .catch(error => {
                toast.error(`There has been an issue contacting Garmin: ${error}`);
                errors.onLoad = "Garmin Connection failed: " + error;
                setErrors(errors);
                setProcessing(false);
            })
    }

    function breakConnection(e) {
        e.preventDefault();
        setProcessing(true);
        disconnect()
            .then(() => {
                setConnectionAuthorised(false);
                toast.success(`Garmin Connect disconnected`);
                setProcessing(false);
            })
            .catch(error => {
                toast.error(`There has been an issue disconnecting: ${error}`);
                errors.onLoad = "Garmin Disconnection failed: " + error;
                setErrors(errors);
                setProcessing(false);
            })
    }

    return (
        processing ?
            <Spinner />
            :
            <div className="">
                <div className="garmin-connect row justify-content-center">
                { connectionAuthorised ?
                        <div className="make-connection col-12 mx-3 col-sm-10 col-lg-8 col-xl-6">
                            {errors.onLoad ?
                                <div className="alert alert-danger" role="alert">
                                    {errors.onLoad}
                                </div>
                                :
                                <React.Fragment>
                                    <div className="garmin-logo">
                                        <img alt="Garmin" src="/resources/images/garminlogo.png" />
                                    </div>
                                    <div className="connect-details">
                                        <h3>Garmin Connect Integrated</h3>
                                        <p>
                                            Your JustGoRide account is connected to Garmin Connect enabling you to download routes direct to your Garmin device.
                                            Just click on the 'Send to Garmin' option in the route viewer!
                                        </p>
                                    </div>
                                    <div className="actions">
                                        <button className="btn btn-link" onClick={breakConnection}>Disconnect</button>
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    :
                    <div className="make-connection col-12 mx-3 col-sm-10 col-lg-8 col-xl-6">
                        {errors.onLoad ?
                            <div className="alert alert-danger" role="alert">
                                {errors.onLoad}
                            </div>
                            :
                            <React.Fragment>
                                <div className="garmin-logo">
                                    <img alt="Garmin" src="/resources/images/garminlogo.png"/>
                                </div>
                                <div className="connect-details">
                                    <h3>Garmin Connect Integration</h3>
                                    <p>
                                        Connecting your JustGoRide and Garmin Connect accounts
                                        will allow you to download routes directly to your Garmin
                                        device with a simple click of a button in the Route Viewer!  
                                    </p>
                                    <p>
                                        Click the 'Connect' button below to start the process. 
                                    </p>
                                </div>
                                <div className="actions">
                                    <button className="btn btn-info" onClick={startConnection}>Connect</button>
                                </div>
                            </React.Fragment>    
                        }
                    </div>

                }
                </div>
            </div>
    );
};

GarminConnectAuthControl.propTypes = {
    user: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
    return {
        user: state.user
    }
}

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(GarminConnectAuthControl);

/*
 <div className="make-connection col-12 mx-3 col-sm-10 col-lg-8 col-xl-6">
                        {errors.onLoad ?
                            <div className="alert alert-danger" role="alert">
                                {errors.onLoad}
                            </div>
                            :
                            <React.Fragment>
                                <div className="garmin-logo">
                                    <img alt="Garmin" src="/resources/images/garminlogo.png" />
                                </div>
                                <div className="connect-details">
                                    <h3>Garmin Connect Integration</h3>
                                    <p>
                                        Your JustGoRide account is Connected to Garmin Connect!
                                    </p>
                                    <p>
                                        This enables you to download routes direct to you Garmin device.
                                    </p>
                                </div>
                                <div className="actions">
                                    <button className="btn btn-link" onClick={breakConnection}>Disconnect</button>
                                </div>
                            </React.Fragment>
                        }

                    </div>

*/


// WEBPACK FOOTER //
// ./src/components/Integrations/Garmin/GarminConnectAuthControl.js